//this function needs to be available in case the dialer.js is not included
//it will be overwritten when dialer.js is included
window.handleConfirmContinueIfActiveCall = function (callbackIfCallCampaign, callbackIfNoCallCampaign) {
    if ($.isFunction(callbackIfNoCallCampaign)) {
        callbackIfNoCallCampaign();
    }
};

//determines if dialer is available or not
window.isDialerAvailable = function () {
    
    //is dialer script included
    if (typeof Dialer === 'undefined') {
        return false;
    };
    
    if (Dialer && Dialer.Globals) {
        return true;
    };

    return false;
};

/*
var handleConfirmContinueIfActiveCallCampaign = function (callbackIfCallCampaign, callbackIfNoCallCampaign) {

    if ((getCurrentCallCampaignId() || isDialerFloaterVisible()) && window.dialerWindow && !window.dialerWindow.closed) {
        Origin.confirm('End Campaign', 'Taking this action will close the dialer window.  Do you want to continue?', function (ok) {
            if ($.isFunction(callbackIfCallCampaign)) {
                callbackIfCallCampaign(ok);
            }
        });
    } else {
        if ($.isFunction(callbackIfNoCallCampaign)) {
            callbackIfNoCallCampaign();
        }
    }
};

var navigateToPageFromDialer = function (url) {

    if (url) {
        Origin.redirect(url);
    }
};

var showOrHideDialerFloater = function(show) {

    if (window.document) {
        var floater = $(window.document).find('.dialer-floater');
        show ? floater.show() : floater.hide();
        return floater;
    }

    return undefined;
};

var isDialerFloaterVisible = function () {

    return $(window.document).find('.dialer-floater').is(':visible');
};

var onDialerWidgetClosing = function () {

    clearCurrentCallCampaignId();
};

var getCurrentCallCampaignId = function () {

    return +$('.action-dial-multiple').attr('data-call-campaign-id');
};

var getCurrentCallCampaignRequestKey = function () {

    return $('.action-dial-multiple').attr('data-call-campaign-request-key');
};

var clearCurrentCallCampaignId = function () {

    var clearCampaignFromRequest = function () {

        Origin.ajax({
            url: '/Dialer/ClearCampaignFromRequest',
            data: {
                requestKey: REQUEST_KEY
            },
            success: function (json) {

            },
            error: function (msg) {
                if (msg == INVALID_REQUEST_KEY) {
                    Origin.redirect(SESSION_TIMEOUT_URL);
                }
                return true;
            }
        });
    };

    clearCampaignFromRequest();

    highlightAllSearchResultRowsAsNone();

    $('.action-dial-multiple, .entityCount').removeAttr('data-call-campaign-request-key').removeAttr('data-call-campaign-id');

};

var getSearchResultRow = function (recordId) {

    return $('#searchResults > tbody > tr[data-recordid="' + recordId + '"]');
};

var getSearchResultRowCallIndicator = function (recordId) {

    return getSearchResultRow(recordId).find('div[title="Called"]');
};

var addPurchasedIndicatorToRow = function (recordId) {

    var indicator = getSearchResultRow(recordId).find('div[title="Exported"]');

    indicator.addClass('purchased');
};

var highlightSearchResultRowAsCalled = function (recordId) {

    var row = getSearchResultRow(recordId),
        indicator = getSearchResultRowCallIndicator(recordId);

    row.removeClass('called calling').addClass('called');
    indicator.removeClass('calling').addClass('called');
};

var highlightSearchResultRowAsCalling = function (recordId) {

    var row = getSearchResultRow(recordId),
        indicator = getSearchResultRowCallIndicator(recordId),
        hadCalledIndicator;

    row.removeClass('called calling').addClass('calling');
    hadCalledIndicator = indicator.hasClass('called');
    indicator.removeClass('called').addClass('calling');

    return hadCalledIndicator;
};

var highlightAllSearchResultRowsAsNone = function () {

    $('#searchResults > tbody > tr').removeClass('called calling').find('div[title="Called"]').removeClass('called calling');
};


var highlightSearchResultRowAsNone = function (recordId, keepCalledIndicator) {

    var row = getSearchResultRow(recordId),
        indicator = getSearchResultRowCallIndicator(recordId);

    row.removeClass('called calling');
    indicator.removeClass('called calling');

    if (keepCalledIndicator) {
        indicator.addClass('called');
    }
};
*/